import React, { useState } from "react";
import { motion } from "framer-motion";
import { Send, CheckCircle } from "lucide-react";
import axios from "axios";
import { API } from "../data/constants";

export default function InsightsSubscribe() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | already | error
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      const res = await axios.post(`${API}/insights/subscribe`, { email });
      if (res.data.status === "already_subscribed") {
        setStatus("already");
      } else {
        setStatus("success");
      }
      setMessage(res.data.message);
      setEmail("");
    } catch {
      setStatus("error");
      setMessage("Something went wrong. Please try again.");
    }
  };

  if (status === "success" || status === "already") {
    return (
      <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}
        className="rounded-2xl border border-emerald-200 bg-gradient-to-br from-emerald-50 to-white p-8 text-center" data-testid="subscribe-success">
        <CheckCircle className="h-10 w-10 text-emerald-600 mx-auto mb-3" />
        <h3 className="text-xl font-bold text-[#0A0A0A] mb-2">{status === "success" ? "You're Subscribed" : "Already Subscribed"}</h3>
        <p className="text-sm text-[#555]">{message}</p>
      </motion.div>
    );
  }

  return (
    <div className="rounded-2xl border border-emerald-700/30 bg-gradient-to-br from-emerald-950 to-[#022c22] p-8 md:p-10" data-testid="subscribe-form">
      <div className="max-w-xl mx-auto text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-gold font-semibold mb-3">Stay Informed</p>
        <h3 className="text-2xl font-bold text-cream mb-2">Get Insights Delivered to Your Inbox</h3>
        <p className="text-sm text-cream/70 mb-6">Real estate financing education, lending strategy, and capital market insights — built for investors and operators.</p>
        <form onSubmit={handleSubmit} className="flex gap-3 max-w-md mx-auto">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
            className="flex-1 rounded-xl border border-emerald-700/50 bg-emerald-900/50 px-4 py-3 text-sm text-cream placeholder:text-cream/40 focus:outline-none focus:border-gold/60 transition-colors"
            data-testid="subscribe-email-input"
          />
          <motion.button
            type="submit"
            disabled={status === "loading"}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            className="rounded-xl bg-gradient-to-r from-emerald-700 to-emerald-800 px-6 py-3 text-sm font-bold text-cream hover:from-emerald-600 hover:to-emerald-700 transition-all flex items-center gap-2 disabled:opacity-50"
            data-testid="subscribe-submit-btn"
          >
            {status === "loading" ? "..." : <><Send className="h-4 w-4" /> Subscribe</>}
          </motion.button>
        </form>
        {status === "error" && <p className="mt-3 text-xs text-red-400">{message}</p>}
        <p className="mt-4 text-[10px] text-cream/40">No spam. Unsubscribe anytime.</p>
      </div>
    </div>
  );
}
